import withImport from './withImport';
export default withImport;
